
export function validateForm(formElements) {
  let isValid = true

  for (let i = 0; i < formElements.length; i++) {
    const element = formElements[i]
    let parent = element.parentNode

    if (element.hasAttribute('required') && !element.value) {
      parent.classList.add('err-validation')
      isValid = false

    } else {
      parent.classList.remove('err-validation')
    }
  }
  
  return isValid
}
